const toHemisphere = (value, positive, negative) =>
  `${Math.abs(value).toFixed(4)}° ${value < 0 ? negative : positive}`;

export const formatCoordinates = ({ latitude, longitude }) =>
  `${toHemisphere(latitude, 'N', 'S')}, ${toHemisphere(longitude, 'E', 'W')}`;

export const coordinatesToPlain = ({ latitude, longitude }) => `${latitude},${longitude}`;

export const googleMapsUrl = (coordinates) =>
  `https://www.google.com/maps?q=${coordinatesToPlain(coordinates)}`;
